import axios from "../../axios-auth";
import { pathOr } from "ramda";
import qs from "qs";
import { i18n } from "../../i18n";

const STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  REQUEST_ERROR: "REQUEST_ERROR",
  FINALIZED: "FINALIZED"
};
const INTERVAL = 5000; //5000000000; //5000;
const state = {
  files: {
    /*
      file.pdf : {
          name:file.pdf,
          hash:abcd
          statsus:STTAUS.FINALIZED
          response : {...},

      }
       */
  },
  timer: null,
  preflightInfo: {}
};

const getters = {
  getPreflightSendData: state => {
    if (Object.keys(state.preflightInfo) == 0) {
      return {};
    }
    return { preflight_values: state.preflightInfo };
  },
  getFiles: state => {
    return state.files;
  },
  getPreflightInfo: state => {
    return state.preflightInfo;
  },
  getPendingHashFiles: state => {
    var hashes = [];
    for (var file in state.files) {
      if (state.files[file].status == STATUS.PENDING) {
        if (!hashes.includes(state.files[file].hash)) {
          hashes.push(state.files[file].hash);
        }
      }
    }
    return { files: hashes.join(",") };
  },
  getHasPendingFiles: state => {
    for (var file in state.files) {
      if (state.files[file].status == STATUS.PENDING) {
        return true;
      }
    }
    return false;
  },
  getTimer: state => {
    return state.timer;
  },
  getPitstopFileStatusResponse: state => file => {
    if (!state.files[file]) {
      return null;
    }
    if (state.files[file].status == STATUS.PENDING) {
      return null;
    } else if (state.files[file].status == STATUS.SUCCESS) {
      // dont show any pitstop information
      return null;
    } else if (state.files[file].status == STATUS.REQUEST_ERROR) {
      return {
        status: STATUS.REQUEST_ERROR
      };
    }

    return state.files[file].response;
  },
  getPitstopFileIsLoading: state => file => {
    if (!state.files[file]) {
      return false;
    }
    if (state.files[file].status == STATUS.PENDING) {
      return true;
    }
    return false;
  }
};

const mutations = {
  addFile: (state, payload) => {
    var sameHashFile = null;
    for (var file in state.files) {
      if (state.files[file].hash == payload.hash) {
        sameHashFile = file;
        break;
      }
    }
    var newFile = {
      [payload.name]: {
        name: payload.name,
        hash: payload.hash,
        product_part: payload.product_part,
        status: sameHashFile ? state.files[file].status : STATUS.PENDING,
        response: sameHashFile ? state.files[file].response : {}
      }
    };

    state.files = { ...state.files, ...newFile };
  },
  deleteFile: (state, payload) => {
    if (state.files[payload]) {
      var files = { ...state.files };
      delete files[payload];
      state.files = files;
    }
  },
  setTimer: (state, payload) => {
    state.timer = payload;
  },
  setErrorCode: state => {
    for (var file in state.files) {
      if (state.files[file].status == STATUS.PENDING) {
        state.files[file] = {
          ...state.files[file],
          status: STATUS.REQUEST_ERROR
        };
      }
    }
  },
  updateFiles: (state, payload) => {
    var files = { ...state.files };
    for (var file in payload) {
      var stateFiles = [];
      for (var tmpFile in files) {
        if (file == files[tmpFile].hash) {
          stateFiles.push(tmpFile);
        }
      }

      if (stateFiles.length == 0) {
        continue;
      }

      for (var stateFile of stateFiles) {
        if (files[stateFile]) {
          if (payload[file].status == "ok" && payload[file].data) {
            files[stateFile] = {
              ...files[stateFile],
              status: STATUS.SUCCESS
            };
          } else if (
            payload[file].status == "pending" ||
            (payload[file].status == "ok" && payload[file].data == undefined)
          ) {
            files[stateFile] = {
              ...files[stateFile],
              status: STATUS.PENDING
            };
          } else {
            files[stateFile] = {
              ...files[stateFile],
              status: STATUS.ERROR,
              response: {
                data: payload[file].data,
                preflight: payload[file].preflight,
                status: payload[file].status
              }
            };
          }
        }
      }
    }

    state.files = files;
  },
  stopTimer: state => {
    if (state.timer) {
      clearInterval(state.timer);
    }
    state.timer = null;
  },
  setPreflightInfo: (state, payload) => {
    var preflightInfo = { ...state.preflightInfo };
    preflightInfo[payload.code] = payload.preflightInfo;
    state.preflightInfo = preflightInfo;
    if (
      payload.request_finalized &&
      state.files[payload.uploadedFile].response
    ) {
      state.files[payload.uploadedFile].response.status = STATUS.FINALIZED;
    }
  },
  removePreflightInfoPP: (state, payload) => {
    var newState = { ...state.preflightInfo };
    if (newState[payload]) {
      delete newState[payload];
      state.preflightInfo = newState;
    }
  }
};

const actions = {
  pitstopAddFile: ({ commit, dispatch, state }, payload) => {
    commit("addFile", payload);
    if (!state.timer) {
      // run now
      dispatch("runPitstop", payload);
      // and setInterval
      var timer = setInterval(() => {
        dispatch("runPitstop", payload);
      }, INTERVAL);
      commit("setTimer", timer);
    }
  },
  pitstopDeleteFile: ({ commit, getters }, payload) => {
    commit("deleteFile", payload);
    if (Object.keys(getters.getFiles).length == 0) {
      commit("stopTimer");
    }
  },
  runPitstop: ({ commit, getters, rootState, rootGetters }, payload) => {
    const files = getters.getFiles;
    const changeOptionsData = rootGetters.getChangeOptionsData;

    if (Object.keys(files).length == 0) {
      commit("stopTimer");
      return;
    }

    let data = getters.getPendingHashFiles;
    for (let file in files) {
      if (!files.hasOwnProperty(file)) {
        continue;
      }
      if (files[file].status != STATUS.PENDING) {
        continue;
      }
      var pages = null;
      var format = null;
      const product_part = files[file].product_part;
      if (getters.getIsMyAccount) {
        var uploadedData = getters.getMyAccountSelection;
        pages = pathOr(null, ["PP_" + product_part, "pages", 0], uploadedData);
        format = pathOr(
          null,
          ["PP_" + product_part, "format", 0],
          uploadedData
        );
      } else {
        pages = pathOr(
          null,
          ["pp_opt", "PP_" + product_part, "pages", 0],
          changeOptionsData
        );
        format = pathOr(
          null,
          ["pp_opt", "PP_" + product_part, "format", 0],
          changeOptionsData
        );
      }
      data[files[file].hash] = { pages, format, product_part };
    }
    if (i18n.locale) {
      data["lang"] = i18n.locale;
    }
    data["isPackaging"] = getters.getConfig.enable_packaging
      ? getters.getConfig.enable_packaging
      : 0;

    axios.instance
      .post(getters.getUrl(axios.checkPreflight), qs.stringify(data))
      .then(response => {
        //console.log(response.data);
        if (response.data.success && response.data.files) {
          commit("updateFiles", response.data.files);

          if (!getters.getHasPendingFiles) {
            commit("stopTimer");
          }
        }
      })
      .catch(error => {
        commit("setErrorCode");
        commit("stopTimer");
        console.log(error);
      });
  },
  setPreflightInfo: ({ commit }, payload) => {
    commit("setPreflightInfo", payload);
  },

  removePreflightInfoPP: ({ commit }, payload) => {
    commit("removePreflightInfoPP", payload);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
